import { IProceedOnFieldActionsResponse } from "js/@types/DexeroFDForms";

export interface IDexeroSwagger {
  initSwaggerClient(DCA: IDexeroCore): Promise<ISwagger>;
  getSwaggerClient(): Promise<ISwagger>;
  shimSwaggerClient(client: ISwagger): Promise<ISwagger>;
}

function _proceedOnFieldActions(swaggerObj: {
  body: IDCA.IGenericObj;
  fieldIdentifier: any;
  formIdentifier: string;
  lang: string;
  ownerIdentifier: string;
}): Promise<{ obj: IProceedOnFieldActionsResponse }> {
  return new Promise<{ obj: IProceedOnFieldActionsResponse }>((resolve, reject) => {
    const {
      body,
      fieldIdentifier,
      formIdentifier,
      lang = window.language,
      ownerIdentifier,
    } = swaggerObj;
    const uuid = body.uuid || '';

    const url = `${window.location.protocol}//${window.location.host
      }/services/app/${ownerIdentifier}/forms/${formIdentifier}/on_field_actions/${fieldIdentifier}?lang=${lang}&uuid=${uuid}&cacheBust=${+ new Date()}`;
    const data = body || {};
    $.ajax({
      url,
      type: 'POST',
      contentType: 'text/plain',
      data: JSON.stringify(data),
      headers: {
        'x-dex-referer': `${window.location.protocol}//${window.location.host
          }${window.location.pathname}${window.location.search}`,
      },
      success: function (response) {
        resolve({ obj: response });
      },
      error: function (error) {
        reject(error);
        console.error('There was an error!', error);
      }
    });
  });
}

const DexeroSwagger: IDexeroSwagger = {
  initSwaggerClient(_DCA: IDexeroCore) {
    return new Promise((resolve, reject) => {
      try {
        window.DexeroCoreApp.swaggerClientIsInitializing = true;
        const specUrl = '/WebserviceAppApi.view';
        const customSpecUrl = _DCA ? _DCA.userOptions.swaggerJsonUrl : false;

        new window.SwaggerClient({
          requestInterceptor(req: { url: string; headers: IDCA.IGenericObj }) {
            if (window.csrfToken) {
              req.headers['X-CSRF-TOKEN'] = window.csrfToken;
            }
            return req;
          },
          url: customSpecUrl || specUrl,
          usePromise: true,
        })
          .then((client: ISwagger) => window.DexeroCoreApp.shimSwaggerClient(client))
          .then((client: ISwagger) => {
            // / DURING DEV ///
            window.swaggerClient = client;
            window.DexeroCoreApp.swaggerClient = client;
            window.DexeroCoreApp.swaggerClientIsInitializing = false;
            resolve(window.DexeroCoreApp.swaggerClient);
          });
      } catch (e) {
        window.DexeroCoreApp.swaggerClientIsInitializing = false;
        reject(e);
      }
    });
  },

  shimSwaggerClient(client: ISwagger) {
    return new Promise((resolve, reject) => {
      try {
        if (client && client.apis && client.apis.forms && typeof client.apis.forms.proceedOnFieldActions === 'function') {
          return resolve(client);
        }
        /* We need to shim proceedOnFieldActions */
        // @ts-expect-error we have to do this since it's a temp patch
        client.apis.forms = {}
        // @ts-expect-error we have to do this since it's a temp patch
        client.apis.forms.proceedOnFieldActions = _proceedOnFieldActions;

        return resolve(client);
      } catch (error) {
        console.warn('Unable to shim swagger client');
        resolve(client)
      }
    });
  },

  getSwaggerClient() {
    let checkForClientInterval: any;
    let checkCount = 0;
    return new Promise((resolve, reject) => {
      function getClient(): Promise<ISwagger> {
        return new Promise<ISwagger>((_resolve, _reject) => {
          try {
            if (Object.hasOwnProperty.call(window.DexeroCoreApp, 'swaggerClient')) {
              _resolve(window.DexeroCoreApp.swaggerClient as ISwagger);
            } else if (window.DexeroCoreApp.swaggerClientIsInitializing) {
              checkForClientInterval = setInterval(() => {
                if (Object.hasOwnProperty.call(window.DexeroCoreApp, 'swaggerClient')) {
                  clearInterval(checkForClientInterval);
                  _resolve(window.DexeroCoreApp.swaggerClient as ISwagger);
                } else {
                  checkCount += 1;
                  if (checkCount > 10) {
                    clearInterval(checkForClientInterval);
                    _reject();
                  }
                }
              }, 100);
            } else {
              window.DexeroCoreApp.initSwaggerClient(window.DexeroCoreApp).then(
                (client: ISwagger) => {
                  _resolve(client);
                }
              );
            }
          } catch (e) {
            _reject();
          }
        });
      }

      getClient().then(
        (client: ISwagger) => {
          resolve(client);
        },
        () => {
          reject();
        }
      );
    });
  },
};

export default DexeroSwagger;
